uniform sampler2D uSheet;
uniform float uLogDepthBufFC;
uniform vec3  uSkyTop;           // hemisphere-averaged HDR irradiance, upper half (linear)
uniform vec3  uSkyBottom;        // hemisphere-averaged HDR irradiance, lower half (linear)
uniform float uEffectBrightness; // per-scenario dim for the env-lit term (fire untouched)
uniform vec4  uFire;             // x = lum low, y = lum high, z = warmth gain, w = emissive gain

in vec2  vUv;
in float vAlpha;
in float vFragDepth;

out vec4 fragColor;

// Bias toward sky-top, as on the particles — a billboard has no real normal,
// but a smoke column catches more light from above than below.
const float SKY_UP_WEIGHT = 0.7;

void main() {
  vec4 tex = texture(uSheet, vUv);
  float a = tex.a * vAlpha;
  if (a < 0.003) discard;

  // The sheet is uploaded as sRGB, so this is already linear.
  vec3 color = tex.rgb;

  // Fire mask, derived from the footage's own colour rather than a second
  // texture. Two terms, because neither alone covers the range: the core
  // clips to white and carries no hue at all, so luminance has to find it,
  // while the orange skirt is far darker but strongly red-biased, so warmth
  // extends the mask down into it. Smoke is near-neutral and near-black, and
  // scores ~0 on both.
  float lum  = max(max(color.r, color.g), color.b);
  float warm = clamp((color.r - color.b) * uFire.z, 0.0, 1.0);
  float fire = clamp(smoothstep(uFire.x, uFire.y, lum) + warm, 0.0, 1.0);

  // Smoke is lit by the sky; fire lights itself. Same hemispheric term and
  // Reinhard ceiling the particles use, so the billboard sits in the same
  // light as the puffs thrown around it instead of reading as a decal.
  vec3 envLight = mix(uSkyBottom, uSkyTop, SKY_UP_WEIGHT);
  envLight = envLight / (vec3(1.0) + envLight);
  envLight *= 2.0 * uEffectBrightness;
  color *= mix(envLight, vec3(1.0), fire);

  // Emissive boost — pushes the fireball over the bloom threshold.
  color *= 1.0 + fire * uFire.w;

  // Premultiply — renderer uses premultipliedAlpha (default)
  fragColor = vec4(color * a, a);

  // Logarithmic depth buffer — must write gl_FragDepth for correct depth test
  gl_FragDepth = log2(vFragDepth) * uLogDepthBufFC * 0.5;
}
